import { Routes } from '@angular/router';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { authGuard } from './features/auth/auth.guard';
import { HomeComponent } from './features/landing-page/home.component/home.component';
import { PrivacyPolicyComponent } from './features/landing-page/privacy-policy-component/privacy-policy-component';
import { TermsAndConditionsComponent } from './features/landing-page/terms-and-conditions-component/terms-and-conditions-component';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthGetUserDetail } from './features/auth/auth.action';
import { map } from 'rxjs';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'portal',
    loadChildren: () => import('./features/portal/portal.module').then((m) => m.PortalModule),
    canMatch: [authGuard],
    resolve: {
      tokens: () => {
        const store = inject(Store);
        return store.dispatch(new AuthGetUserDetail(false, true)).pipe(map(() => true));
      },
    },
  },
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
  },
  {
    path: 'contact-us',
    pathMatch: 'full',
    loadChildren: () =>
      import('./features/contact-us/contact-us-module').then((m) => m.ContactUsModule),
  },
  {
    path: 'billytics-login',
    redirectTo: 'auth',
  },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'billytics-terms-and-conditions',
    pathMatch: 'full',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import('./features/invitation/accept-invitation.component').then(
        (m) => m.AcceptInvitationComponent,
      ),
    canMatch: [],
  },
  {
    path: 'tenant-selector',
    loadComponent: () =>
      import('./features/tenant-selector/tenant-selector.component').then(
        (m) => m.TenantSelectorComponent,
      ),
    canMatch: [authGuard],
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },
];
